import React, { useCallback, useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
import Select from 'react-select';
import dataExcel from '../../../jsons/modelo-confianza.json';

import {listaColoresChart} from '../../../Components/shared/colores';
import PackeBubbleChart from '../../../Components/highChart/packet-bubbleChart-v2';

type listItemT = {
  label: string,
  value: string
}

const defaultData = {
  label: '',
  data: [],
  borderColor: '',
  fill: false,
  tension: 0.4,
};

const ChartV5: React.FC = (props: any) => {
  const nameTitle = "Modelo de Confianza en Gabriel Boric";

  const [allData, setAllData]=useState([])

  const [valuesSelected, setValuesSelected] = useState([]);
  //----
  
  const [currentDatasetItem, setCurrentDatasetItem] = useState([]);

  
  const [arrayColores, setArrayColores] = useState(listaColoresChart);



  const setDataGrafico = (data: any) => {
    //console.log(data);
    let arrayAux: any = [];
    data.map((item: any) => {
      let objAux: any = {};
      // delete item.created_on;
      // delete item.id;
      for (const key in item) {
        if (key.toString() === "Modelo de Confianza en Gabriel Boric") {
          objAux['nombre'] = item[key];

        }
      }
      for (const key in item) {
        if (key.toString() !== "Modelo de Confianza en Gabriel Boric") {
          objAux["- " + key.toString() + " -"] = item[key.toString()] ? item[key.toString()] : '-';
        }
      }
      arrayAux.push(objAux);
    })
    //console.log(arrayAux);
    const updatedItemsDataset: any = [];
    valuesSelected.forEach((valor: any) => {
      let datasetItem = arrayAux.find((item: any) => item.nombre === valor.value);
      if (datasetItem) {
        updatedItemsDataset.push(datasetItem);
      }
    })
    console.log(updatedItemsDataset);
    return updatedItemsDataset;
  }

   const exportExcel = (params:any) => {

  //   const allDataGraf: any = allData[0];
  //   console.log(allDataGraf);
  //   console.log(params);
  //   //Creo un nuevo excel
     const wb = XLSX.utils.book_new();

  //   //Se setean los datos al formato para el excel
     const data = XLSX.utils.json_to_sheet(setDataGrafico(dataExcel.Hoja1));

  //   //Se crea una pagina por cada cada grafico con sus respectivos datos
     XLSX.utils.book_append_sheet(wb, data, 'Modelo de confianza');

  //   //Se descarga el excel
    XLSX.writeFile(wb, "Data " + "Modelo-de-confianza" + ".xlsx")
   }


   const settingData: any = (data: any) => {
    console.log(data);
    if (data) {
      let response: any =[

      ]
      let iKey = 0
      for (const key in data) {
        let obj:any = {
            name:key,
            data:[]
        }
        const auxName = "Modelo de Confianza en Gabriel Boric"
        console.log(data);
        data[key].data.map((item:any)=>{
            let auxObj:any = {name:'', value:0}
            for (const key in item) {
                //console.log(auxName);
                //console.log(item[key].toLowerCase());
                if(auxName.toLowerCase() == key.toLowerCase()){
                    auxObj.name = item[key]
                }else{
                    auxObj.value = parseFloat(item[key])
                }
                
            }
            obj.data.push(auxObj)
        })
        response.push(obj)
        // console.log(key)
        //let value: any = data[key];
        // if (key == "Modelo de Confianza en Gabriel Boric") {
        //   response.name = value;
        // } else {
        //   if(value != "-"){
        //     // console.log(key)
        //     response.data.push([iKey, parseInt(value)]);
        //   } 
        //   iKey++;
          // else {
            // response.data.push([key, 0]);
          // }
        //}
      }
      console.log(response);
      return response;
    } else {
      return 'No Data'
    }
  }

  const getLabels = () => {
    let arrayAux: any = [],
    arrayAux2: any = [];

    dataExcel.Hoja1.forEach((dataItem:any) => {
      valuesSelected.map((item: any) => {
        if(item.value == dataItem[nameTitle]){
          arrayAux.push(dataItem);
        }
      });
    });
    arrayAux.map((item: any) => {
      for (const key in item) {
        if(key !== nameTitle){
          arrayAux2.push(key);
        }
      }
    })
    const uwu: any = new Set(arrayAux2);
    console.log( [...uwu]);
    return [...uwu];
  }

  const arrayDataset = async () => {
    // console.log("Acá")
    let arrayItem: any = [];
    await dataExcel.Hoja1.reduce(async (waitExcel, dataItem) => {
      await waitExcel;
      // console.log(`VALUE ::: ${arrayItem}`)
      const dataFormat = await settingData(dataItem);
      // console.log(`FORMAT ::: ${arrayItem}`)
      arrayItem.push(dataFormat);
    }, Promise.resolve()); 
    return arrayItem;
    // setCurrentDataSet(arrayItem);
  }

  useEffect(() => {
    // declare the data fetching function
    const fetchData = async () => {
      const data = await arrayDataset();
      // console.log("acá 1")
      return data
    }

    // call the function
    fetchData()
      .then(data => setCurrentDatasetItem(data))
      .catch(console.error);
    // let array: any = [];
    // dataExcel.Hoja1.map((dataItem: any) => {
    //   array.push(settingData(dataItem));
    // })
    // setCurrentDataSet(array);

    // let valoresDefault: any = [
    //   {
    //     "label": "Promedio mensual apruebo",
    //     "value": "Promedio mensual apruebo"
    //   }, {
    //     "label": "Promedio mensual rechazo",
    //     "value": "Promedio mensual rechazo"
    //   }
    // ];
    // uploadDefaultData(valoresDefault);
  }, [])

  const customStyles = {
    option: (provided : any, state : any) => ({
      ...provided,
      padding: 4,
      fontSize:12,
      
    }),
    multiValue: (base:any, state:any) => {
      return  { ...base, fontSize: 14 };
    },
    // control: () => ({
    //   // none of react-select's styles are passed to <Control />
    //   width: 200,
    // }),
    singleValue: (provided : any, state : any) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

  
      return { ...provided, opacity, transition };
    }
  }

  return (
    <div className="shadow p-3 mb-5 bg-body rounded chart-content">
      <div className='mt-3'>
        
       <PackeBubbleChart 
            allData={currentDatasetItem} 
            label={getLabels()} 
            exportExcel={exportExcel}  
            activeButton={valuesSelected.length > 0 ? true:false} 
        /> 
      </div>
    </div>
  )
}

export default ChartV5;